import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  constructor(private cookieService: CookieService) {}

  // 存储 Token
  saveCookies(name:string,content: any): void {
    this.cookieService.set(name, content, {
      // expires: 1, // 过期时间为 1 天
      // secure: true, // 仅通过 HTTPS 传输
      sameSite: 'Lax', // 减少 CSRF 攻击的风险
      path: '/' // Cookie 适用于整个域名
    });
  }

  // 获取 Token
  getCookie(name:string): string {
    return this.cookieService.get(name);
  }

  // 删除 Token
  deleteCookies(name:string): void {
    this.cookieService.delete(name, '/'); // 删除时要指定相同的 path
  }
}
